(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-scrolling-images"] && !Shopify.designMode) return;
  try {
    
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ScrollingImages extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  // Section lifecycle

  connectedCallback() {
    this.scrollingImageContent = this.querySelectorAll('[data-scrolling-image-content]'); // wrapper containing images
    if (!this.scrollingImageContent.length) return;
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.#initScroll();
    this.#handleResize();
    this.#setupTouchClick();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.unobserve(this);
      this.observer = null;
    };
    if (this.ro) {
      this.ro.unobserve(this);
      this.ro = null;
    };
  }

  #handleResize() {
    if (this.ro) return;

    this.ro = new ResizeObserver(
      debounce(() => {
        this.#initScroll();
      }, 50)
    );

    this.ro.observe(this);
  }

  #initScroll() {
    this.scrollingImageContent.forEach((el) => {
      // Get gap from custom element attributes instead of computed style
      const isDesktop = window.matchMedia('(min-width: 480px)').matches;
      const imageGap = parseInt(
        isDesktop 
          ? this.getAttribute('image-gap-desktop') 
          : this.getAttribute('image-gap-mobile'),
        10
      );
      
      const marqueeItems = el.querySelectorAll(
        '[data-scrolling-image-content-item]:not([data-is-clone])'
      );
      
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items using data attributes from individual items
      let totalItemWidth = [...marqueeItems].reduce(
        (total, item) => {
          const itemWidth = parseInt(
            isDesktop 
              ? item.dataset.desktopWidth 
              : item.dataset.mobileWidth,
            10
          );
          return total + (itemWidth + imageGap);
        },
        0
      );


      if (totalItemWidth > 0) totalItemWidth -= imageGap;

      // Ensure we have enough content for smooth infinite scroll (minimum 2 sets)
      const numImageGroups = Math.max(2, Math.ceil((width * 1.5) / Math.max(totalItemWidth, 1)));
      
      // Check how many clone groups we currently have
      const existingClones = el.querySelectorAll('[data-is-clone="true"]');
      const currentCloneGroups = existingClones.length / marqueeItems.length;
      
      // Only modify clones if the required number has changed
      if (Math.floor(currentCloneGroups) !== numImageGroups - 1) {
        // Remove existing clones
        existingClones.forEach(clone => clone.remove());
        
        // Clone and append marquee items if we don't have enough to fill the container
        for (let i = 1; i < numImageGroups; i++) {
          marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-is-clone', 'true');
            el.appendChild(clone);
          });
        }
      }

      // Adjust animation duration based on the number of cloned groups to maintain consistent speed
      if (numImageGroups > 1) {
        const originalDuration = parseFloat(getComputedStyle(this).getPropertyValue('--duration'));
        const adjustedDuration = originalDuration * numImageGroups;
        el.style.setProperty('--duration', `${adjustedDuration}s`);
      }
    });

    if (!this.observer) {
      this.#observeAnimations();
    }
  }

  #observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      this.classList.toggle('scrolling-images--is-animated', isIntersecting);
    });
    this.observer.observe(this);
  }

  #setupTouchClick() {
    if (!window.matchMedia('(pointer: coarse)').matches || !this.pauseOnHover) return;
    
    this.addEventListener('click', (e) => {
      this.paused = !this.paused;
      this.scrollingImageContent.forEach((el) => {
        el.style.animationPlayState = this.paused ? 'paused' : 'running';
      });
    });
  }
}

customElements.define('scrolling-images', ScrollingImages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoBannerSection extends Section {
 constructor($root) {
   super($root);
   this.$root = $root;
   this.$video = this.query('.pxu-video-banner__video');
   this.id = $root.id;
   this.data = this.loadData();
   this.observer = null;

   this.onMount();
 }

 onMount() {
   this.initIntersectionObserver();
 }

 onUnmount() {
   if (this.observer) {
     this.observer.unobserve(this.$root);
   }
 }

 initIntersectionObserver() {
   this.observer = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         if (this.$video) {
           this.initShopifyVideo();
         }
         observer.unobserve(this.$root);
       }
     });
   }, { threshold: 0 });
   this.observer.observe(this.$root);
 }

 initShopifyVideo() {
   if (!this.$video) return;
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

   if(prefersReducedMotion){
    this.$video.removeAttribute('autoplay');
    this.$video.setAttribute('controls', '');
   } else {
    this.$video.play();
   }
 }
}

document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
 Section.init($section, VideoBannerSection);
});

if (Shopify.designMode) {
 window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
}
  } catch(e) { console.error(e); }
})();
})();
